import type { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { checkIsDocumentViewer } from "./checkIsDocumentViewer";

const sanitizeFileName = (name: string): string => {
    // Убираем все .pdf / .ppt / .pptx (без учёта регистра), если они идут в конце
    return name.replace(/(\.(pdf|pptx?|PDF|PPTX?))+$/g, "");
};

const isValidFileName = (name: string): boolean => {
    const regex =
        /^(?!^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$)(?![ .])(?!.*[ .]$)[a-zA-Zа-яА-Я0-9 _.,\-()]{1,255}$/;
    return regex.test(name);
};

export function renameDocument(name: string, canvInstance: typeof canv) {
    const selectedEntities = canvInstance.canvasController.selected;

    if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
        const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
        if (child && checkIsDocumentViewer(child)) {
            const newName = sanitizeFileName(name.trim());
            const input = document.querySelector<HTMLInputElement>(".documentPageInputField");
            if (isValidFileName(newName)) {
                if (input) input.value = newName;
                child.reNameDocument(newName);
            } else {
                canvInstance.widgetMenu.reopen();
            }
        }
    }
}
